import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { TombolaPage } from './pages/TombolaPage';
import { WalletPage } from './pages/WalletPage';
import { BadgesPage } from './pages/BadgesPage';
import { ProfilePage } from './pages/ProfilePage';
import { Navigation } from './components/Navigation';
import { DriverProvider } from './context/DriverContext';
export function App() {
  return <DriverProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="min-h-screen bg-gray-50" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/login" element={<LoginPage data-id="element-5" />} data-id="element-4" />
            <Route path="/" element={<TombolaPage data-id="element-7" />} data-id="element-6" />
            <Route path="/wallet" element={<WalletPage data-id="element-9" />} data-id="element-8" />
            <Route path="/badges" element={<BadgesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/profile" element={<ProfilePage data-id="element-13" />} data-id="element-12" />
          </Routes>
          <Navigation data-id="element-14" />
        </div>
      </BrowserRouter>
    </DriverProvider>;
}